<template>
  <div class="product-header-parent">
    <h1>{{ name }}</h1>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, default: '' },
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/global.less';

.product-header-parent {
  display: inline-block;
  width: fit-content;
}
</style>
